import { Link } from 'react-router-dom'
import InfoButton from '../../../components/InfoButton/InfoButton'
import '../Section.css'
import './ListsIndex.css'

function ListsIndex() {
  return (
    <div className="dashboard-section">
      <h1>
        Lists
        <InfoButton
          title="Lists"
          content={
            <div>
              <p>
                Need a shot list for your photographer? A checklist for flowers? A packing list for the big day? 
                Create and edit your own lists so nothing gets forgotten (and no one says "we missed the confetti photo").
              </p>
              <p>
                <strong>Available Lists:</strong>
              </p>
              <ul>
                <li><strong>Must-Capture Moments:</strong> Photo shot list for your photographer</li>
                <li><strong>The Soundtrack:</strong> Your wedding playlist and music selections</li>
                <li><strong>Bloom Board:</strong> Floral arrangements and flower preferences</li>
                <li><strong>Wedding Cargo:</strong> Packing list for the big day</li>
              </ul>
              <p>
                All in one place, stress-free.
              </p>
            </div>
          }
        />
      </h1>
      <div className="subsections-grid">
        <Link to="/dashboard/lists/must-capture-moments" className="subsection-card">
          <h3>Must-Capture Moments</h3>
        </Link>
        <Link to="/dashboard/lists/the-soundtrack" className="subsection-card">
          <h3>The Soundtrack</h3>
        </Link>
        <Link to="/dashboard/lists/bloom-board" className="subsection-card">
          <h3>Bloom Board</h3>
        </Link>
        <Link to="/dashboard/lists/wedding-cargo" className="subsection-card">
          <h3>Wedding Cargo</h3>
        </Link>
      </div>
    </div>
  )
}

export default ListsIndex
